export const organisationType = user => ['PRODUCTION_COMPANY', 'ADVERTISING_AGENCY'].includes(user?.accountType) ? user.accountType : null;
export const organisationLabel = user => organisationType(user) === 'PRODUCTION_COMPANY' ? 'Production Company' : organisationType(user) === 'ADVERTISING_AGENCY' ? 'Advertising Agency' : '';
export const subscriptionCountry = user => {
  const normalize = value => {
    const country = String(value || '').trim().toUpperCase();
    if (country === 'AUSTRALIA') return 'AU';
    if (country === 'NEW ZEALAND') return 'NZ';
    return /^[A-Z]{2}$/.test(country) ? country : null;
  };
  return normalize(user?.billingCountry) || normalize(user?.estimatedCountry) || normalize(user?.country) || normalize(user?.countryCode) || 'US';
};
export const subscriptionCurrency = user => ['AU', 'NZ'].includes(subscriptionCountry(user)) ? 'AUD' : 'USD';
export const seatPrices = seats => seats <= 1 ? [14.99, 24.99] : seats <= 5 ? [13.99, 23.99] : seats <= 10 ? [12.99, 22.99] : [11.99, 21.99];
export const isAustralianCustomer = user => subscriptionCountry(user) === 'AU';
export const isNewZealandCustomer = user => subscriptionCountry(user) === 'NZ';
// Mirrors backend/src/lib/subscription-live.js auGstBreakdown: 10% Australian GST is added
// on top of the exclusive base price, never deducted from it (14.99 -> 1.50 -> 16.49).
export const auGstBreakdown = price => {
  const base = Math.round(price * 100);
  const gst = Math.round(base * 0.10);
  return { base: base / 100, gst: gst / 100, total: (base + gst) / 100 };
};
export const trialDaysRemaining = (end, now = Date.now()) => {
  const time = new Date(end).getTime();
  return end && Number.isFinite(time) ? Math.max(0, Math.min(7, Math.ceil((time - now) / 86400000))) : null;
};